// src/index.ts
import { useCallback } from "react";
import { useController, useForm, useFormContext } from "react-hook-form";
function useHybridInput({ name = "", externalOnChange, externalOnBlur, externalValue, defaultValue, options }) {
  const form = useFormContext();
  const { control: fallbackControl } = useForm();
  const { field: { onChange: internalOnChange, onBlur: internalOnBlur, value: internalValue }, fieldState: { error } } = useController({ name, control: (form == null ? void 0 : form.control) ?? fallbackControl, rules: options, defaultValue });
  const value = form && name ? internalValue : externalValue;
  const onChange = useCallback((value2) => {
    internalOnChange == null ? void 0 : internalOnChange(value2);
    return externalOnChange == null ? void 0 : externalOnChange(value2);
  }, [externalOnChange, internalOnChange]);
  const onBlur = useCallback((e) => {
    externalOnBlur == null ? void 0 : externalOnBlur(e);
    internalOnBlur == null ? void 0 : internalOnBlur();
  }, [externalOnBlur, internalOnBlur]);
  return { value, onChange, onBlur, error };
}
export {
  useHybridInput as default
};
